import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./LoginSlice";
import searchReducer from "./searchSlice";
import checkoutReducer from "./CheckoutAddressSlice";
import chatName from "./ChatUserNameSlice";
import cartListSlice from "./cartListSlice";
import landingPageSlice from "./landingPageSlice";

export const store = configureStore({
  reducer: {
    Login: loginReducer,
    search: searchReducer,
    checkout: checkoutReducer,
    chatName: chatName,
    cartData: cartListSlice,
    landingPage: landingPageSlice
  },
});
